module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"SuccessfulImports":"Erfolgreiche Importe: %{count}","importCustomersButtonText":"Kunden"},"en":{"SuccessfulImports":"Successful imports: %{count}","importCustomersButtonText":"Customers"}}')
  delete Component.options._Ctor
}
